<script lang="ts" setup>
import { Layer } from '@/components/layer'
import GoodsImage from '~/components/common/modules/units/goods-image.vue'
import { MOBILE_IMAGE_SIZE } from '~/constants/common/index'
import { GiftListItem } from '~/api/types/goods'

export interface Props {
  modelValue: boolean
  unitCd: number
  items: GiftListItem[]
}

const props = withDefaults(defineProps<Props>(), {})
const emit = defineEmits<(event: 'update:modelValue', result: boolean) => void>()

const state = reactive({
  isShow: props.modelValue
})

const isError = ref<boolean>(false)
const giftBnftList = computed(() => props.items?.filter(item => item.goodsCd === props.unitCd))

watch(
  () => props.modelValue,
  newItems => {
    if (newItems) {
      state.isShow = true
    } else {
      state.isShow = false
    }
  },
  { immediate: true }
)

const _callbackClose = () => {
  emit('update:modelValue', false)
}
const _callbackOpen = () => {}

function onError() {
  isError.value = true
}
</script>

<template>
  <Layer
    class="modal-detail-gift-wrap"
    v-model="state.isShow"
    layer-type="full"
    @on-close="_callbackClose"
    @on-open="_callbackOpen"
  >
    <template #header>구성품 전체보기</template>
    <template #contents>
      <div class="modal-detail-gift">
        <div class="gift-wrap" v-for="(item, index) in giftBnftList" :key="index">
          <dl>
            <dd class="gift-list">
              <div class="row" v-for="(giftItem, giftIdx) in item.unitList" :key="giftIdx">
                <figure v-if="!isError">
                  <GoodsImage
                    :goods-cd="item.goodsCd"
                    :config="{
                      width: MOBILE_IMAGE_SIZE.DETAIL_UNIT.FREEBIES.WIDTH,
                      height: MOBILE_IMAGE_SIZE.DETAIL_UNIT.FREEBIES.HEIGHT,
                      alt: giftItem.unitNm
                    }"
                    @on-error="onError"
                  />
                </figure>
                <div class="gift-info">
                  <p class="text">{{ giftItem.unitNm }}</p>
                </div>
              </div>
            </dd>
          </dl>
        </div>
      </div>
    </template>
  </Layer>
</template>

<style lang="scss">
@use '~/pages/goods/scss/layer/modal-detail-gift';
</style>
